import React from 'react';
import reactDom from 'react-dom';
import { useHistory } from 'react-router-dom';
import iconCnfrmBook from '../../assets/images/booking_confirmation.svg'

export default function ConfirmBookingMessage() {
    const history = useHistory();
    return reactDom.createPortal(
        <div class="modal">
			<div class="modal-content">
				<div class="modal-body">
                    <div class="generate-popup">
                        <div class="img-circle">
                            <img alt='Confirm booking icon' src={iconCnfrmBook}/>
                            <h4>Congratulations!</h4>
                            <p>Your parking space is booked and confirmation mail has been sent to your registered email.</p>
                        </div>
                        <button onClick={() => history.push(`/home`)}>Go back to Home</button>
                    </div>
				</div>
			</div>
		</div>
    ,document.body)
}
